/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { eventControllerCancelV1 } from '../fn/event/event-controller-cancel-v-1';
import { EventControllerCancelV1$Params } from '../fn/event/event-controller-cancel-v-1';
import { eventControllerCreateV1 } from '../fn/event/event-controller-create-v-1';
import { EventControllerCreateV1$Params } from '../fn/event/event-controller-create-v-1';
import { eventControllerDeleteV1 } from '../fn/event/event-controller-delete-v-1';
import { EventControllerDeleteV1$Params } from '../fn/event/event-controller-delete-v-1';
import { eventControllerFindAllV1 } from '../fn/event/event-controller-find-all-v-1';
import { EventControllerFindAllV1$Params } from '../fn/event/event-controller-find-all-v-1';
import { eventControllerFindByIdV1 } from '../fn/event/event-controller-find-by-id-v-1';
import { EventControllerFindByIdV1$Params } from '../fn/event/event-controller-find-by-id-v-1';
import { eventControllerSearchCursorV1 } from '../fn/event/event-controller-search-cursor-v-1';
import { EventControllerSearchCursorV1$Params } from '../fn/event/event-controller-search-cursor-v-1';
import { eventControllerSearchV1 } from '../fn/event/event-controller-search-v-1';
import { EventControllerSearchV1$Params } from '../fn/event/event-controller-search-v-1';
import { eventControllerUpdateV1 } from '../fn/event/event-controller-update-v-1';
import { EventControllerUpdateV1$Params } from '../fn/event/event-controller-update-v-1';
import { EventDto } from '../models/event-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class EventService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `eventControllerSearchV1()` */
  static readonly EventControllerSearchV1Path = '/api/v1/event/search';

  /**
   * Event 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerSearchV1$Response(params?: EventControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<EventDto>;
}>> {
    return eventControllerSearchV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Event 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerSearchV1(params?: EventControllerSearchV1$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<EventDto>;
}> {
    return this.eventControllerSearchV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<EventDto>;
}>): OffsetPaginationDto & {
'items'?: Array<EventDto>;
} => r.body)
    );
  }

  /** Path part for operation `eventControllerSearchCursorV1()` */
  static readonly EventControllerSearchCursorV1Path = '/api/v1/event/search/cursor';

  /**
   * Event 커서 기반 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventControllerSearchCursorV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerSearchCursorV1$Response(params?: EventControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<EventDto>;
}>> {
    return eventControllerSearchCursorV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Event 커서 기반 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventControllerSearchCursorV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerSearchCursorV1(params?: EventControllerSearchCursorV1$Params, context?: HttpContext): Observable<CursorPaginationDto & {
'items'?: Array<EventDto>;
}> {
    return this.eventControllerSearchCursorV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<EventDto>;
}>): CursorPaginationDto & {
'items'?: Array<EventDto>;
} => r.body)
    );
  }

  /** Path part for operation `eventControllerFindAllV1()` */
  static readonly EventControllerFindAllV1Path = '/api/v1/event';

  /**
   * 모든 Event 목록 조회.
   *
   * status 쿼리 파라미터로 필터링 가능
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerFindAllV1$Response(params?: EventControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EventDto>>> {
    return eventControllerFindAllV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 Event 목록 조회.
   *
   * status 쿼리 파라미터로 필터링 가능
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerFindAllV1(params?: EventControllerFindAllV1$Params, context?: HttpContext): Observable<Array<EventDto>> {
    return this.eventControllerFindAllV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EventDto>>): Array<EventDto> => r.body)
    );
  }

  /** Path part for operation `eventControllerCreateV1()` */
  static readonly EventControllerCreateV1Path = '/api/v1/event';

  /**
   * Event 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventControllerCreateV1$Response(params: EventControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<EventDto>> {
    return eventControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Event 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventControllerCreateV1(params: EventControllerCreateV1$Params, context?: HttpContext): Observable<EventDto> {
    return this.eventControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<EventDto>): EventDto => r.body)
    );
  }

  /** Path part for operation `eventControllerFindByIdV1()` */
  static readonly EventControllerFindByIdV1Path = '/api/v1/event/{id}';

  /**
   * Event id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerFindByIdV1$Response(params: EventControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<EventDto>> {
    return eventControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Event id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerFindByIdV1(params: EventControllerFindByIdV1$Params, context?: HttpContext): Observable<EventDto> {
    return this.eventControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<EventDto>): EventDto => r.body)
    );
  }

  /** Path part for operation `eventControllerDeleteV1()` */
  static readonly EventControllerDeleteV1Path = '/api/v1/event/{id}';

  /**
   * Event 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerDeleteV1$Response(params: EventControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return eventControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Event 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerDeleteV1(params: EventControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.eventControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `eventControllerUpdateV1()` */
  static readonly EventControllerUpdateV1Path = '/api/v1/event/{id}';

  /**
   * Event 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventControllerUpdateV1$Response(params: EventControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<EventDto>> {
    return eventControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Event 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventControllerUpdateV1(params: EventControllerUpdateV1$Params, context?: HttpContext): Observable<EventDto> {
    return this.eventControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<EventDto>): EventDto => r.body)
    );
  }

  /** Path part for operation `eventControllerCancelV1()` */
  static readonly EventControllerCancelV1Path = '/api/v1/event/{id}/cancel';

  /**
   * Event 상태를 취소(CANCELLED)로 변경.
   *
   * 행사의 상태를 CANCELLED로 명시적으로 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventControllerCancelV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerCancelV1$Response(params: EventControllerCancelV1$Params, context?: HttpContext): Observable<StrictHttpResponse<EventDto>> {
    return eventControllerCancelV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Event 상태를 취소(CANCELLED)로 변경.
   *
   * 행사의 상태를 CANCELLED로 명시적으로 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventControllerCancelV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerCancelV1(params: EventControllerCancelV1$Params, context?: HttpContext): Observable<EventDto> {
    return this.eventControllerCancelV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<EventDto>): EventDto => r.body)
    );
  }

}
